import { createFileRoute } from '@tanstack/react-router';
import { SocWall } from '@/components/wall/soc-wall';

export const Route = createFileRoute('/wall/soc')({ component: SocWall });
